module.exports = __webpack_public_path__ + "static/media/app-window-link.c34974a0.svg";